/**
 * Shared source-document separator semantics for every export channel.
 */

/** Markdown thematic break consumed by the PDF and Word renderers. */
export const SOURCE_DOCUMENT_SEPARATOR_MARKDOWN = "---";

/** Plain-text equivalent used by clipboard exports. */
export const SOURCE_DOCUMENT_SEPARATOR_TEXT =
  "────────────────────────────────";
